import { BlockMath, InlineMath } from "react-katex";
import "katex/dist/katex.min.css";
import Markdown from 'markdown-to-jsx';
import { View  } from "react-native";



// BDD 11/21/2025 - New for font control of Answers from AI
// Escape LaTeX for safe passage through markdown-to-jsx,
// then unescape inside KaTeX component overrides below.
const _escapeForMarkdown = (raw) => {
  let eq = raw.trim().replace(/\s+/g, " ");
  eq = eq.replace(/\\left/g, "").replace(/\\right/g, "");
  eq = eq.replace(/\\/g, "\\\\");
  eq = eq.replace(/_/g, "\\_");
  eq = eq.replace(/}/g, "\\}").replace(/{/g, "\\{");
  return eq;
};

// Reverse the markdown escaping so KaTeX sees the original LaTeX
const _unescapeForKatex = (escaped) => {
  let eq = String(escaped);
  eq = eq.replace(/\\{/g, "{").replace(/\\}/g, "}");
  eq = eq.replace(/\\_/g, "_");
  eq = eq.replace(/\\\\/g, "\\");
  return eq;
};

const MarkdownRenderer = ({ content }) => {
  // Guard against null/undefined content
  if (!content || typeof content !== "string") return null;

  // Normalize LaTeX delimiters: convert \[...\] and \(...\) to $$...$$ and $...$
  const normalized = content
    .replace(/\\\[([\s\S]*?)\\\]/g, (_, eq) => `$$${eq}$$`)
    .replace(/\\\((.*?)\\\)/g, (_, eq) => `$${eq}$`);

  const preProcessedContent = normalized
    .replace(/\$\$(.*?)\$\$/gs, (_, equation) => {
      return `<BlockMath>${_escapeForMarkdown(equation)}</BlockMath>`;
    })
    .replace(/\$(.*?)\$/g, (_, equation) => {
      return `<InlineMath>${_escapeForMarkdown(equation)}</InlineMath>`;
    });

  return (
    <View>
      <Markdown
        className="ai-answer-markdown"    // 👈 NEW: scoped CSS hook
        options={{
          overrides: {
            BlockMath: {
              component: ({ children }) => {
                try {
                  let equation = Array.isArray(children)
                    ? children.join("")
                    : children;
                  equation = _unescapeForKatex(equation);
                  return <BlockMath>{equation}</BlockMath>;
                } catch {
                  return <code>{String(children)}</code>;
                }
              },
            },
            InlineMath: {
              component: ({ children }) => {
                try {
                  let equation = Array.isArray(children)
                    ? children.join("")
                    : children;
                  equation = _unescapeForKatex(equation);
                  return <InlineMath>{equation}</InlineMath>;
                } catch {
                  return <code>{String(children)}</code>;
                }
              },
            },
          },
        }}
      >
        {preProcessedContent}
      </Markdown>
    </View>
  );
};

export default MarkdownRenderer;
